import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "icon", "disabled", "intent", "size", "variant", "type"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { IconWrapper } from '@flowio/react-icon-wrapper';
import React from 'react';
import ButtonBase from './ButtonBase';
import getIconWidth from '../utilities/getIconWidth';

var iconStyle = function iconStyle(size) {
  return /*#__PURE__*/css({
    flex: 'none',
    display: 'inline-block',
    width: "".concat(getIconWidth(size), "px"),
    height: 'auto',
    verticalAlign: 'middle',
    fill: 'currentcolor'
  }, process.env.NODE_ENV === "production" ? "" : ";label:iconStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0ljb25CdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVUwRCIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9JY29uQnV0dG9uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IEljb25XcmFwcGVyIH0gZnJvbSAnQGZsb3dpby9yZWFjdC1pY29uLXdyYXBwZXInO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCB0eXBlIHsgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBCdXR0b25CYXNlIGZyb20gJy4vQnV0dG9uQmFzZSc7XG5pbXBvcnQgZ2V0SWNvbldpZHRoIGZyb20gJy4uL3V0aWxpdGllcy9nZXRJY29uV2lkdGgnO1xuaW1wb3J0IHR5cGUgeyBCdXR0b25TaXplLCBJY29uQnV0dG9uUHJvcHMgfSBmcm9tICcuLi90eXBlcyc7XG5cbmNvbnN0IGljb25TdHlsZSA9IChzaXplOiBCdXR0b25TaXplKTogU2VyaWFsaXplZFN0eWxlcyA9PiBjc3Moe1xuICBmbGV4OiAnbm9uZScsXG4gIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICB3aWR0aDogYCR7Z2V0SWNvbldpZHRoKHNpemUpfXB4YCxcbiAgaGVpZ2h0OiAnYXV0bycsXG4gIHZlcnRpY2FsQWxpZ246ICdtaWRkbGUnLFxuICBmaWxsOiAnY3VycmVudGNvbG9yJyxcbn0pO1xuXG5jb25zdCBJY29uQnV0dG9uOiBSZWFjdC5GQzxJY29uQnV0dG9uUHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGljb24sXG4gIGRpc2FibGVkID0gZmFsc2UsXG4gIGludGVudCA9ICduZXV0cmFsJyxcbiAgc2l6ZSA9ICdtZWRpdW0nLFxuICB2YXJpYW50ID0gJ3NvbGlkJyxcbiAgdHlwZSA9ICdidXR0b24nLFxuICAuLi51bmhhbmRsZWRQcm9wc1xufSkgPT4gKFxuICA8QnV0dG9uQmFzZVxuICAgIHsuLi51bmhhbmRsZWRQcm9wc31cbiAgICBkaXNhYmxlZD17ZGlzYWJsZWR9XG4gICAgZmx1aWQ9e2ZhbHNlfVxuICAgIGludGVudD17aW50ZW50fVxuICAgIHNpemU9e3NpemV9XG4gICAgdmFyaWFudD17dmFyaWFudH1cbiAgICB0eXBlPXt0eXBlfT5cbiAgICB7Y2hpbGRyZW4gIT0gbnVsbCA/IGNoaWxkcmVuIDogKFxuICAgICAgPEljb25XcmFwcGVyIGNzcz17aWNvblN0eWxlKHNpemUpfSBpY29uPXtpY29ufSAvPlxuICAgICl9XG4gIDwvQnV0dG9uQmFzZT5cbik7XG5cbkljb25CdXR0b24uZGlzcGxheU5hbWUgPSAnSWNvbkJ1dHRvbic7XG5cbmV4cG9ydCBkZWZhdWx0IEljb25CdXR0b247XG4iXX0= */");
};

var IconButton = function IconButton(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$intent = _ref.intent,
      intent = _ref$intent === void 0 ? 'neutral' : _ref$intent,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx(ButtonBase, _extends({}, unhandledProps, {
    disabled: disabled,
    fluid: false,
    intent: intent,
    size: size,
    variant: variant,
    type: type
  }), children != null ? children : jsx(IconWrapper, {
    css: iconStyle(size),
    icon: icon
  }));
};

IconButton.displayName = 'IconButton';
export default IconButton;